var $ = require('../internals/export');
var isRegisteredSymbol = require('../internals/symbol-is-registered');

// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$({ target: 'Symbol', stat: true }, {
  isRegisteredSymbol: isRegisteredSymbol
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/node_modules/core-js-pure/modules/esnext.symbol.is-registered-symbol.js
// module id = sprk
// module chunks = 0